import { BusinessRole } from "shared/enums/BusinessRole";
import { UserIdentity } from "shared/models/UserIdentity";
import { UserIdentityDto } from "tasksBoard/service/api/UserIdentityDto";
import { GrantsFromResponse } from "./GrantsFromResponse";

export class UserIdentityFromResponse {
    constructor(private userIdentityFromResponse: UserIdentityDto) {}

    userIdentity(): UserIdentity {
        return {
            userName: this.userIdentityFromResponse.username,
            email: this.userIdentityFromResponse.email,
            fullName: this.userIdentityFromResponse.fullname,
            businessRole: this.userIdentityFromResponse.businessRole as BusinessRole,
            branchCode: this.userIdentityFromResponse.branchCode,
            grants: new GrantsFromResponse(this.userIdentityFromResponse.grantList).grants()
        };
    }
}
